<template>
  <!-- 电脑端 -->
  <div id="u_r_GUDU16"  @click="u_r_GUDU16_event_03N024($event)"><div id="u_c_IRUE17" class="normal u_c_IRUE17"  ><u_c_B0FU17></u_c_B0FU17><u_c_UBW523></u_c_UBW523><u_c_9B8817></u_c_9B8817></div><u_c_KZMJ21></u_c_KZMJ21><u_c_QIH017></u_c_QIH017></div>
  </template>
<script>
import {reactive,provide,inject,onMounted,watch,ref,computed} from "vue";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash";
import u_c_B0FU17 from "@/components/u_c_B0FU17.vue";import u_c_UBW523 from "@/components/u_c_UBW523.vue";import u_c_9B8817 from "@/components/u_c_9B8817.vue";import u_c_KZMJ21 from "@/components/u_c_KZMJ21.vue";import u_c_QIH017 from "@/components/u_c_QIH017.vue"
export default {
  name: 'router_GUDU16',
  components: {u_c_B0FU17,u_c_UBW523,u_c_9B8817,u_c_KZMJ21,u_c_QIH017},
  setup(){
    const compData = {};
    const routerData = reactive({})
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const { curLang, getLangTxt, langData } = Language();
    // 自定义setup - 开始
    if(utils.isMobileType() && router.hasRoute('m')){
router.gotoRouter("/m")
};
      // 电脑端的click事件
      const u_r_GUDU16_event_03N024= async (e)=>{
        try {
try{
let videoElement = document.getElementsByTagName("video")[0];
if(videoElement){
videoElement.muted = false;
}
}catch(e){}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束
    return {pageData,routerData,langData,u_r_GUDU16_event_03N024}
  }
}
</script>
<style lang="scss" >
.u_c_IRUE17.normal{position:relative;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden;}
</style>
